import React, { useMemo, useState } from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { Col, Row } from "reactstrap";
import Checkbox from "@mui/material/Checkbox";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import {
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import StopIcon from "@mui/icons-material/Stop";
import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import styles from "./pick.module.css";
import MultipleUpdate from "./MultipleUpdate";
import { TimeZone } from "utils/DateFormate";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateEvents } from "api/all.api";
import useGmailStore from "store/gmail";
import { DateConverter } from "utils/DateFormate";

export default function UpdateComponent({
  setOpen,
  event,
  propEvents,
  users,
  setGoogleEvents,
}) {
  const [startDate, setStartDate] = useState(event?.start);
  const [endDate, setEndDate] = useState(
    event?.end ? event?.end : event?.start
  );
  const [startTime, setStartTime] = useState(event?.start);
  const [endTime, setEndTime] = useState(
    event?.end ? event?.end : event?.start
  );
  const [star, setStar] = useState(event?.star);
  const [check, setCheck] = useState(event?.allDay);
  const [color, setColor] = useState(event?.color);
  const [spin, setSpin] = useState(false);
  const [title, setTitle] = useState(event?.title);
  const [desc, setDesc] = useState(event?.desc);
  const [userIds, setUserIds] = useState([]);
  const [personName, setPersonName] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const { googleToken } = useGmailStore();

  const queryClient = useQueryClient();
  const updateMutation = useMutation({
    mutationFn: updateEvents,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        console.log(variables);

        if (variables.googleEventId) {
          const google = variables.googleData;
          setGoogleEvents((prev) =>
            prev.map((item) =>
              item.id === variables.googleEventId
                ? {
                    ...item,
                    title: google.summary,
                    description: google?.description,
                    start: google?.start?.dateTime,
                    end: google?.end?.dateTime,
                  }
                : item
            )
          );
        }
        queryClient.setQueryData(
          ["events", googleToken ? googleToken : "logged_out"],
          (oldEvents) =>
            oldEvents.map((item) =>
              item._id === data.event._id
                ? { id: data?.event?._id, ...data?.event }
                : item
            )
        );
        queryClient.setQueryData(["nameevents"], (oldEvents) =>
          oldEvents.filter((item) => item.eventId !== event.id)
        );
        queryClient.setQueryData(["nameevents"], (oldEvents) => [
          ...oldEvents,
          ...data.userevents,
        ]);

        toast.success(data.message);
        setSpin(false);
        setOpen(false);
      }
    },
    onError: (err) => {
      toast.error(err);
      setSpin(false);
      console.log("Error : ", err);
    },
  });

  useMemo(() => {
    if (propEvents?.length) setIsVisible(propEvents[0].isVisible);
  }, [propEvents]);

  const handleChange = () => {
    setCheck(!check);
  };

  const handleEvent = () => {
    setSpin(true);

    let data;
    let googleData;

    if (check) {
      data = {
        allDay: true,
        title: title,
        description: desc,
        date: event?.start,
        color: color.length ? color : "#999999",
        star: star,
      };
      googleData = {
        summary: title,
        description: desc,
        start: {
          date: event.start,
        },
        end: {
          date: new Date(new Date(event.start).getTime() + 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0],
        },
        reminders: {
          useDefault: true,
        },
      };
    } else {
      data = {
        title: title,
        description: desc,
        date: null,
        allDay: false,
        star: star,
        start:
          startDate?.toISOString()?.slice(0, 10) +
          " " +
          TimeZone(startTime)?.toLocaleTimeString(navigator.language, {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          }),
        end:
          endDate?.toISOString()?.slice(0, 10) +
          " " +
          TimeZone(endTime)?.toLocaleTimeString(navigator.language, {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          }),
        color: color.length ? color : "#999999",
      };

      googleData = {
        summary: title,
        description: desc,
        start: {
          dateTime: `${DateConverter(startDate)}T${
            TimeZone(startTime).toISOString().split("T")[1]
          }`,
        },
        end: {
          dateTime: `${DateConverter(endDate)}T${
            TimeZone(endTime).toISOString().split("T")[1]
          }`,
        },
        reminders: {
          useDefault: true,
        },
      };
    }

    const eventdetail = {
      name: data.title,
      startDate: data?.start?.split(" ")[0],
      endDate: data?.end?.split(" ")[0],
    };

    updateMutation.mutate({
      eventdetail,
      data,
      id: event.id,
      isVisible,
      userIds,
      googleToken,
      googleData,
      googleEventId: event?.googleEventId
        ? event?.googleEventId
        : event.googleEvent,
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Row className="mb-4 ml-1 justify-content-between">
        <div>
          <FormControl variant="standard" sx={{ minWidth: 70 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              displayEmpty
              value={color}
              onChange={(e) => setColor(e.target.value)}
              label="color"
            >
              <MenuItem value={color}>
                <StopIcon sx={{ color: "#999999" }} />
              </MenuItem>
              <MenuItem value={"#FF3366"}>
                <StopIcon sx={{ color: "#FF3366" }} />
              </MenuItem>
              {/* Red */}
              <MenuItem value={"#ed6c02"}>
                <StopIcon sx={{ color: "#ed6c02" }} />
              </MenuItem>
              {/* Yellow */}
              <MenuItem value={"#0288d1"}>
                <StopIcon sx={{ color: "#0288d1" }} />
              </MenuItem>
              {/* Blue */}
              <MenuItem value={"#006600"}>
                <StopIcon sx={{ color: "#006600" }} />
              </MenuItem>
              {/* Green */}
              <MenuItem value={"#9c27b0"}>
                <StopIcon sx={{ color: "#9c27b0" }} />
              </MenuItem>
              {/* Purple */}
            </Select>
          </FormControl>
        </div>
        <div style={{ display: "flex" }}>
          {star ? (
            <IconButton color="primary" onClick={() => setStar(false)}>
              <StarIcon />
            </IconButton>
          ) : (
            <IconButton onClick={() => setStar(true)}>
              <StarBorderIcon className="" />
            </IconButton>
          )}
          <Checkbox
            size="small"
            checked={check}
            onChange={handleChange}
            className="pt-0 pb-0"
          />
          <Typography className={styles.allDay}>All-Day</Typography>
        </div>
      </Row>
      <Row>
        <Col sm={12} md={6}>
          <MobileDatePicker
            label="Start Date"
            disabled={check}
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </Col>
        <Col sm={12} md={6} className={styles.time_margin}>
          <MobileTimePicker
            label="Start Time"
            disabled={check}
            value={startTime}
            onChange={(newValue) => {
              setStartTime(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col sm={12} md={6}>
          <MobileDatePicker
            label="End Date"
            disabled={check}
            value={endDate}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </Col>
        <Col sm={12} md={6} className={styles.time_margin}>
          <MobileTimePicker
            label="End Time"
            disabled={check}
            value={endTime}
            onChange={(newValue) => {
              setEndTime(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6} sm={12}>
          <TextField
            label="Event Title"
            size="small"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Col>
        <Col md={6} sm={12} className={styles.time_margin}>
          <TextField
            label="Event Description"
            size="small"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            multiline
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col sm={12}>
          <MultipleUpdate
            setUserIds={setUserIds}
            propEvents={propEvents}
            personName={personName}
            setPersonName={setPersonName}
            users={users}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col sm={12}>
          <IconButton className="py-0" onClick={() => setIsVisible(!isVisible)}>
            {isVisible ? (
              <VisibilityIcon sx={{ color: "#97c3e6" }} />
            ) : (
              <VisibilityOffIcon />
            )}
          </IconButton>
          Share with Users
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Button
            size="small"
            variant="contained"
            color="success"
            className={styles.add_btn}
            onClick={handleEvent}
          >
            {spin ? <CircularProgress size={18} color="inherit" /> : "Update"}
          </Button>
        </Col>
      </Row>
    </LocalizationProvider>
  );
}
